/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


// PDP Features Accordions
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.pdp_accordion-button').forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('pdp_accordion--active')
        })
    })
    document.querySelectorAll('.menu_button').forEach(button => {
        button.addEventListener('click', () => {
            button.classList.toggle('menu_button--active')
        })
    })
})

/*Quick add*/

const addProductToCart = function (el) {
  
  let variant_id ;
  if(el.hasClass("quick-add-variants__button_variant1")){
    variant_id = el.attr("data-variantid");
  }else{
    variant_id = el.parent().find(".quick-add-variants__item.true.active").attr("data-variantid");
  }
  if(variant_id !== undefined){
    el.text("Adding...");
    let items = [];
    items.push({
      id: variant_id,
      quantity: "1"
    });
    let formData = {
     'items': items
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      
      return response.json();
    })
    .then(data => {
      el.after(`<p class="success-select-option">Added product</p>`);
      $(".Header__CartDot").addClass("is-visible");
      el.text("Add to cart");
      let currCartQuantity = Number($("#cart-quantity-indicator").text());
      $("#cart-quantity-indicator").text(currCartQuantity  + 1);
      setTimeout(function () {
        $(".success-select-option").remove();
      }, 2000);
    })
    .catch((error) => {
      el.text("Add to cart");
      console.error('Error:', error);
    });
  }else{
    el.after(`<p class="error-select-option">Select option</p>`);
    setTimeout(function () {
      $(".error-select-option").remove();
    }, 2000);
  }
  
}

/*End Quick add*/

const  getMobileOperatingSystem = function() {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}


$(document).ready(function(){  
    
  if($(".template-index").length > 0){
    $('.slider-homepage .owl-carousel').owlCarousel({
      loop: true,
      margin: 0,
      responsiveClass: true,
      nav: true,
      animateOut: 'fadeOut',
      smartSpeed: 1000,
      center:true,
      touchDrag:true,
      autoplay:true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    });

    $("#slider-homepage .owl-prev, .slider-homepage .owl-prev").html('<img  src="https://cdn.shopify.com/s/files/1/0209/9829/1520/files/next.png?v=1572379466" alt="">')
    $("#slider-homepage .owl-next, .slider-homepage .owl-next").html('<img   src="https://cdn.shopify.com/s/files/1/0209/9829/1520/files/next.png?v=1572379466" alt="">')

    $('#slider-homepage .owl-carousel .item, .slider-homepage .owl-carousel .item').on("click", function(){
      var hrefthis = $(this).attr("data-href");
      window.location.href = hrefthis;
    });
  }
  
  $(document).on("click", "#active_size", function(){
    $(".size-guide-popup").addClass("active")
  })

  $(document).on("click", ".size-guide-popup .close-pop", function(){
    
    $(".size-guide-popup").removeClass("active")
  })

  /*Quick add*/

  $(document).on("click", ".quick-add-variants__button", function(){
    $(this).parents(".quick-add-variants").find(".quick-add-variants__items").addClass("active");
  })

  $(document).on("mouseover",".quick-add-variants__items", function(){
     $(this).addClass("active");
  });

  $(document).on("mouseout",".quick-add-variants__items", function(){
    $(this).removeClass("active");
  });

  $(document).on("click", ".quick-add-variants__item.true", function(e){
    e.preventDefault();
    $(".quick-add-variants__item").removeClass("active");
    $(this).addClass("active");
  })

  $(document).on("click", ".quick-add-to-cart__button, .quick-add-variants__button_variant1", function(e){
    e.preventDefault();
    addProductToCart($(this))
  })


  /*End Quick add*/

  let itemForDesktop = $("#featured-collection-homepage").attr("data-desktop"),
      itemForMobile = $("#featured-collection-homepage").attr("data-mobile")

  $('#featured-collection-homepage .owl-carousel').owlCarousel({
    stagePadding: 0,
    loop:true,
    margin:30,
    nav:true,
    touchDrag:true,
    responsiveClass: true,
    responsive:{
      0:{
        items:itemForMobile,
        stagePadding: 0,
        margin:5,
      },
      500:{
        items:3,
        stagePadding: 0,
        margin:5,
      },
      769:{
        items:itemForDesktop
      },
      1000:{
        items:itemForDesktop
      }
    }
  });
  $(".owl-nav .owl-prev, .owl-nav .owl-next").text("");
  $(".owl-nav .owl-prev, .owl-nav .owl-next").html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>');

  setTimeout(function(){
    $('.owl-carousel').owlCarousel({
      loop:true,
      margin:10,
      nav:true,
      responsive:{
        0:{
          items:2,
          margin:5
        },
        600:{
          items:3
        },
        1000:{
          items:4,
          margin:15
        }
      }
    })
    $(".owl-nav .owl-prev, .owl-nav .owl-next").text("");
    $(".owl-nav .owl-prev, .owl-nav .owl-next").html('<svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>');

  },2000)


  var checkout_link = "https://www.femcurves.com/cart/";
  let generateCheckoutLink = function(items){
    console.log(items)
    for(var i in items) {
       console.log(i, items[i]);
       checkout_link += items[i].id+":"+items[i].quantity+","
    }
    checkout_link =  checkout_link.slice(0, -1)
    console.log(checkout_link)
    window.location.href=checkout_link;
  }
  /*
  $(document).on('click',  '.octocode-checkout', function(e){
      e.preventDefault();
      console.log("CREA LINK CHECKOUT")
      $(this).text("Processing...")
      fetch('/cart.js')
      .then(response => response.json())  // convertir a json
      .then(json =>
        generateCheckoutLink(json.items))
      .catch(err => console.log('Solicitud fallida', err)); // Capturar errores
  });
  */

  let currentMobileOperatingSystem = getMobileOperatingSystem();
  if(currentMobileOperatingSystem === "iOS" || currentMobileOperatingSystem === "Android"){
    $(".footer-get-app").show();
    if(currentMobileOperatingSystem == "iOS"){
      $(".footer-get-app__button__link.ios").show();
    }else{
      $(".footer-get-app__button__link.android").show();
    }
  }
 
  
})


